import { ALL_DATA_TYPES, type DataTypeType } from '@repo/advanced-filters';
import dayjs from 'dayjs';
import Linkify from 'linkify-react';

export default function RenderDataByDataType({
  value,
  dataType,
  className = '',
  withoutSeconds,
  skipEmailFormat,
}: {
  value: string | string[] | undefined;
  dataType: DataTypeType;
  className?: string;
  withoutSeconds?: boolean;
  skipEmailFormat?: boolean;
}) {
  if (value) {
    if (Array.isArray(value)) {
      return (
        <span className={className}>
          {value.map((v) => (
            <span key={v}>
              <RenderDataByDataType value={v} dataType={dataType} />
            </span>
          ))}
        </span>
      );
    } else if (dataType === ALL_DATA_TYPES.date && dayjs(value).isValid()) {
      return dayjs(value).format('DD/MM/YYYY');
    } else if (dataType === ALL_DATA_TYPES.datetime && dayjs(value).isValid()) {
      return dayjs(value).format(`DD/MM/YYYY hh:mm${withoutSeconds ? '' : ':ss'} A`);
    } else {
      return (
        <Linkify
          options={{
            target: '_blank',
            rel: 'noopener noreferrer',
            validate: {
              email: () => !skipEmailFormat,
            },
          }}
        >
          {value}
        </Linkify>
      );
    }
  } else {
    return null;
  }
}
